export default "__VITE_ASSET__iCZ0acjX__"